import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from "@angular/core";
import type { SimpleChanges } from "@angular/core";
import { KeyValuePair } from "../../../../models/key-value-pair";
import { FilterService } from "../../../../services/filter.service";

@Component({
  standalone: false,
  selector: "dua-line-number-picker",
  templateUrl: "./line-number-picker.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./line-number-picker.component.scss"],
})
export class LineNumberPickerComponent implements OnInit, OnChanges {
  @Output() closeFilter: EventEmitter<boolean> = new EventEmitter();

  @Input() lineNumbers: string[] = [];
  checkedStatusForLineNumbers: KeyValuePair<string, boolean>[] = [];
  allChecked = true;

  constructor(private filterService: FilterService) {}

  ngOnInit(): void {
    this.syncFromInputs();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["lineNumbers"]) {
      this.syncFromInputs();
    }
  }

  close() {
    this.closeFilter.emit(true);
  }

  onLineCheckedChange(lineNumber: string, checked: boolean) {
    this.checkedStatusForLineNumbers.forEach((x) => {
      if (x.key === lineNumber) {
        x.value = checked;
      }
    });
    this.refreshAllChecked();
    this.emitActiveValues();
  }

  onAllCheckedChange(checked: boolean) {
    this.allChecked = checked;
    this.checkedStatusForLineNumbers.forEach((x) => {
      x.value = checked;
    });
    this.emitActiveValues();
  }

  private syncFromInputs() {
    const filterLines = this.filterService.getFilter().lines;
    const treatAsAll = !filterLines?.length;
    this.checkedStatusForLineNumbers =
      this.lineNumbers?.map(
        (x) => new KeyValuePair(x, treatAsAll || filterLines.includes(x))
      ) ?? [];
    this.refreshAllChecked();
  }

  private refreshAllChecked() {
    this.allChecked =
      this.checkedStatusForLineNumbers.length > 0 &&
      this.checkedStatusForLineNumbers.every((x) => x.value);
  }

  private emitActiveValues() {
    const activeLineNumbers = this.checkedStatusForLineNumbers
      .filter((x) => x.value)
      .map((x) => x.key);

    // Empty array means "all lines" in FilterService.
    const lines = this.allChecked ? [] : activeLineNumbers;
    this.filterService.setLines(lines);
  }
}
